module.exports = __webpack_public_path__ + "static/team11-e11a16fbb573bd1ae85814eeaef3f8e7.jpg";